import React, { createContext, useContext, useState, useEffect } from 'react';

const CustomerContext = createContext();

export const useCustomer = () => {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error('useCustomer must be used within a CustomerProvider');
  }
  return context;
};

export const CustomerProvider = ({ children }) => {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if customer is logged in on app start
    const customerId = localStorage.getItem('customerId');
    const customerEmail = localStorage.getItem('customerEmail');
    const customerName = localStorage.getItem('customerName');

    if (customerId && customerEmail) {
      setCustomer({
        id: customerId,
        email: customerEmail,
        name: customerName
      });
    }
    setLoading(false);
  }, []);

  const login = (customerData) => {
    setCustomer(customerData);
    localStorage.setItem('customerId', customerData.id);
    localStorage.setItem('customerEmail', customerData.email);
    localStorage.setItem('customerName', customerData.name);
  };

  const logout = () => {
    setCustomer(null);
    localStorage.removeItem('customerId');
    localStorage.removeItem('customerEmail');
    localStorage.removeItem('customerName');
  };

  const value = {
    customer,
    loading,
    login,
    logout,
    isLoggedIn: !!customer
  };

  return (
    <CustomerContext.Provider value={value}>
      {children}
    </CustomerContext.Provider>
  );
}; 